module.exports = __webpack_public_path__ + "static/img/16areaB_5.f8d0f8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/16areaB_5.png
// module id = 1134
// module chunks = 1